import $ from 'jquery';
import _ from 'underscore';
import toastr from 'toastr';
import { t } from 'app/libWrappers/i18next.wrapper';
import makeSticky from 'app/lib/stickyContainer/stickyContainer';

const STICKY_TOAST_CONTAINER_ID = 'toast-container';
const STICKY_TOAST_NAMESPACE = 'stickyToast';
const STICKY_TOAST_SPACING = 30;
const BANNER_DELAY = 500;

let clearSticky;
const makeStickyToastContainer = () => {
    if (!clearSticky) {
        let $stickyToastContainer = $('<div>', { id: STICKY_TOAST_CONTAINER_ID });
        $('body').append($stickyToastContainer);

        clearSticky = makeSticky($stickyToastContainer, null, STICKY_TOAST_NAMESPACE, STICKY_TOAST_SPACING);
    }
};

const clearStickyToastContainer = () => {
    if (clearSticky && $(STICKY_TOAST_CONTAINER_ID).children().length === 0) {
        clearSticky(); // makeSticky returns a function that will clear events/timers when called
        clearSticky = null;
    }
};

toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    preventDuplicates: true,
    onclick: null,
    containerId: STICKY_TOAST_CONTAINER_ID,
    toastClass: 'toast-normal',
    messageClass: 'toast-normal__content',
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
    onHidden: () => clearStickyToastContainer()
};

const BANNER_OPTIONS = {
    tapToDismiss: false,
    timeOut: 0,
    extendedTimeOut: 0,
    showDuration: 400,
    hideDuration: 400,
    containerId: 'toast-banner-container',
    toastClass: 'toast-banner',
    messageClass: 'toast-banner__content',
    showMethod: 'slideDown',
    hideMethod: 'slideUp',
    positionClass: null,
    onShown: null,
    onHidden: null
};

// NOTE - please pass HTML to these functions rather than plaintext.
// Plaintext should be escaped with _.escape before passing, especially if it comes from user input.
let message = {
    _showMessage: function (message, type, options, actionArgs) {
        let messageEncoded = message.replace(/\n/g, '<br/>');

        let optionsToUse = options || {};
        if (actionArgs) {
            const { actionCallback, actionId, actionText } = actionArgs;
            messageEncoded = $(`<div style="display: flex">${messageEncoded}</div>`);
            const $action = $(`<a class="toast-action" id="${_.uniqueId(`${actionId}_`)}">${actionText}</a>`);
            $action.click(actionCallback);
            messageEncoded.append($action);
            optionsToUse = {
                ...optionsToUse,
                timeOut: 6000,
                closeButton: false
            };
        }
        optionsToUse.closeHtml = `<button class="toast-dismiss-button">${t('common:dismiss')}</button>`;

        makeStickyToastContainer();
        const title = null;
        return toastr[type](messageEncoded, title, optionsToUse);
    },

    showError: function (message, actionArgs) {
        return this._showMessage(message, 'error', {}, actionArgs);
    },

    showSuccess: function (message, actionArgs) {
        return this._showMessage(message, 'success', {}, actionArgs);
    },

    showNotice: function (message, actionArgs) {
        return this._showMessage(message, 'info', {}, actionArgs);
    },

    showProcessing: function (promise, loadingMessage, completeMessage, errorMessage) {
        let processingMessage = this._showMessage(loadingMessage, 'info', {
            iconClass: 'toast-processing',
            timeOut: 0,
            extendedTimeOut: 0
        });
        promise
            .then(() => {
                processingMessage?.remove();
                this.showSuccess(completeMessage);
            })
            .catch(() => {
                processingMessage?.remove();
                this.showError(errorMessage);
            });
    },

    _showBanner: function (message, isDismissible = true, type, actionArgs) {
        this._showMessage(
            message,
            type,
            {
                ...BANNER_OPTIONS,
                closeButton: Boolean(isDismissible)
            },
            actionArgs
        );
    },

    showInfoSuccessBanner: function (message, isDismissible = true, actionArgs) {
        this._showBanner(message, isDismissible, 'success', actionArgs);
    },

    showErrorWarningBanner: function (message, isDismissible = true, actionArgs) {
        this._showBanner(message, isDismissible, 'error', actionArgs);
    },

    handleErrorResponse(messagePrefix, response, defaultMessage) {
        let message;
        let responseContent = response.responseJSON;
        if (responseContent && responseContent.errorKey) {
            message = t(`${messagePrefix}${responseContent.errorKey}`);
        }
        message = message || defaultMessage || responseContent?.developerMessage || 'Error';
        this.showError(message);
    },

    clearNotices() {
        return toastr.clear();
    },

    removeToast() {
        let toastrEl = $(`#${BANNER_OPTIONS.containerId}`);
        toastrEl.slideUp(BANNER_DELAY, () => {
            toastrEl.remove();
        });
    }
};

export default message;
